import React, { useState, useEffect, useRef } from "react";
import { Badge, Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import jwt_decode from "jwt-decode";
import { ROUTES } from "../../constants/webRouting";
import { formatDate, formatDateForCreatedDate, formatDateForView, getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";



const WarrantyView = () => {
  const userInfo = getUserDetails();
  // console.log("WarrantyView Call");
  const location = useLocation();
  const navigate = useNavigate();
  const [warranty, setWarranty] = useState(location.state ? location.state : {});
  // console.log('warranty', warranty);


  const [modalShow, setModalShow] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState(false);

  const [relatedListFiles, setRelatedListFiles] = useState(true);


  const [showDetails, setShowDetails] = useState(true);
  const [showNotesMessages, setShowNotesMessages] = useState(false);

  const [editDisable, setDisableEdit] = useState(true);

  useEffect(() => {
    // let userInfoJWT = jwt_decode(localStorage.getItem("token"));
    // setUserInfo(userInfoJWT);
    fetchOffer();
    // (userInfoJWT.id === warranty.owner_id) && setDisableEdit(false);
  }, []);

  const fetchOffer = () => {
    if (!warranty.id && location.hasOwnProperty("pathname") && location.pathname.split("/").length >= 3) {
      warranty.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await fuziElevatorsApi.fetchWarrantyById(warranty.id);
      if (result) {
        setWarranty(result);
      } else {
        setWarranty({});
      }
    }
    init();
  };

  const deleteWarranty = async () => {
    const result = await fuziElevatorsApi.deleteWarranty(warranty.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
    navigate(ROUTES.WARRANTY.LIST);
  };

  const edit = () => {
    navigate(`${ROUTES.WARRANTY.LIST}/${warranty.id}/e`, { state: warranty });
  };


  const handleTab = (key) => {
    if (key === "details") {
      setShowDetails(true);
      setShowNotesMessages(false);
    } else if (key === "notesMessages") {
      setShowDetails(false);
      setShowNotesMessages(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    fetchOffer();
  };

  // const submitTasks = () => {
  //     setModalShowTask(false);
  //     setRefreshTaskList((prev) => !prev);
  // };

  const handleRelatedListTab = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
    }
  };

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(`${warranty.site_address}`); // Default address

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude, address]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };


  return (
    <Container className="pb-5">
      {warranty && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteWarranty={deleteWarranty}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="warranty"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  onClick={() => navigate(ROUTES.WARRANTY.LIST)}
                >
                  Warranty
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3 sticky-card-header-view">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={8}>
                    <h6 className="m-0 ">Warranty</h6>
                    <h4 className="m-0 ">
                      {warranty.offer_name_label || ""}
                    </h4>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end gap-3">
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_WARRANTY].some(permission => {
                      return userInfo?.permissions?.map(p => p.name).includes(permission);
                    }) && (
                        <Button
                          size="sm"
                          className="btn-edit"
                          onClick={() => edit(true)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                      )}

                    {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_WARRANTY].some(permission => {
                      return userInfo?.permissions?.map(p => p.name).includes(permission);
                    }) && (
                        <Button
                          size="sm"
                          className="btn-delete"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button>
                      )}
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader className="sticky-tabs-header">
                  <Col lg={12} className="mt-4" style={{ color: "#fff" }}>
                    <Tabs
                      defaultActiveKey="details"
                      id="uncontrolled-tab-example"
                      onSelect={(key) => handleTab(key)}
                      style={{ marginBottom: "12px" }}
                    >
                      <Tab eventKey="details" title="Details"></Tab>
                      {/* <Tab
                                                eventKey="notesMessages"
                                                title="Notes & Messages"
                                            ></Tab> */}
                    </Tabs>
                  </Col>
                </CardHeader>

                <CardBody className="card-body-scroll">
                  <Container>
                    {showDetails && (
                      <Row className="">
                        <>
                          <Col lg={6}>
                            <label>Job Number</label>
                            <span>{warranty.job_no || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Order</label>
                            <span>{warranty.offer_name_label || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Lead</label>
                            <span>{warranty.lead_name || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Status</label>
                            <span>{warranty.warranty_status || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Email</label>
                            <span>{warranty.email || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Phone</label>
                            <span>{warranty.phone || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>WhatsApp Number</label>
                            <span>{warranty.whatsapp_no || ""}</span>
                          </Col>
                          {/* formatDateForView added by shahir hussain 27-08-2025 */}
                          <Col lg={6}>
                            <label>Date of Birth</label>
                            <span>{formatDateForView(warranty?.date_of_birth || "")}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Anniversary Date</label>
                            <span>{formatDateForView(warranty?.anniversary_date || "")}</span>
                          </Col>
                          {/* <Col lg={6}>
                            <label>Assigned User</label>
                            <span> 
                              <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                              <img
                                src={localStorage.getItem("myimage")}
                                className="rounded-circle"
                                style={{ height: "30px" }}
                                alt=""
                              />

                              <Badge
                                bg="warning"
                                className="mx-2"
                                style={{ display: "inline", color: "#000" }}
                              >
                                {warranty?.owner_name || ""}
                              </Badge>
                            </span>
                          </Col> */}
                          <Col lg={6}>
                            <label>Assigned Users</label>
                            <span>
                              <div className="d-flex flex-wrap gap-1">
                                {warranty?.owner_ids?.map((item) =>
                                  <Badge
                                    bg="warning"
                                  >
                                    <Link to={`${ROUTES.USER.LIST}/${item.value}`} className="text-decoration-none text-dark fw-bold">
                                      {item.label}
                                    </Link>
                                  </Badge>
                                )}
                              </div>
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Created Date</label>
                            <span>
                              {formatDateForView(
                                warranty?.createddate || ""
                              )}
                            </span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            CUSTOMER INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>Customer Type</label>
                            <span>{warranty.customer_type || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Company Name</label>
                            <span>{warranty.company_name || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Sector</label>
                            <span>{warranty.sector || ""}</span>
                          </Col>
                          {/* <Col lg={6}>
                            <label>Is GST Applicable</label>
                            <span>{warranty?.is_gst || ""}</span>
                          </Col>  */}
                          {warranty?.is_gst === "Yes" && (
                            <Col lg={6}>
                              <label>GST Number</label>
                              <span>{warranty?.gst_number || ""}</span>
                            </Col>
                          )}
                          <Col lg={6}>
                            <label>GST Billing Name</label>
                            <span>{warranty?.gst_billing_name || ""}</span>
                          </Col>
                          {/* Add Segment Type by shahir hussain 02-02-2026 */}
                          <Col lg={6}>
                            <label>Segment Type</label>
                            <span>{warranty?.segment || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            WARRANTY INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>Lead Type</label>
                            <span>{warranty.lead_type || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Quantity</label>
                            <span>{warranty?.qty || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Warranty Period</label>
                            <span>{warranty?.warranty_upto || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Warranty Service Frequency</label>
                            <span>{warranty?.warranty_service_frequency || ""}</span>
                          </Col>
                          {warranty?.warranty_service_frequency && (
                            <>
                              <Col lg={6}>
                                <label>Warranty Start Date</label>
                                <span>{formatDateForView(warranty?.warranty_start_date || "")}</span>
                              </Col>
                              <Col lg={6}>
                                <label>Warranty Upto</label>
                                <span>
                                  {warranty?.warranty_end_date
                                    ? formatDateForView(warranty.warranty_end_date)
                                    : ""}
                                </span>
                              </Col>
                            </>
                          )}
                          <Col lg={6}>
                            <label>Building Location</label>
                            <span>{warranty.building_location || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Cabin Metal</label>
                            <span>{warranty.cabin_metal || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Side</label>
                            <span>{warranty.door_side || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Panels</label>
                            <span>{warranty.door_panels || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Same Side</label>
                            <span>{warranty.same_side || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Metal</label>
                            <span>{warranty.door_metal || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Type</label>
                            <span>{warranty.door_type || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Make</label>
                            <span>{warranty.door_make || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Is Geared</label>
                            <span>{warranty.is_geared || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>DLP Period</label>
                            <span>{warranty.dlp_period || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Motor Make</label>
                            <span>{warranty.motor_make || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Control Panel Make</label>
                            <span>{warranty.control_panel_make || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Control Panel Detail</label>
                            <span>{warranty.control_panel_detail || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>ARD Make</label>
                            <span>{warranty.ard_make || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Passenger Capacity</label>
                            <span>{warranty.passenger_capacity || ""}{warranty.passenger_capacity ? <> KG</> : ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Total Stops</label>
                            <span>{warranty.total_stops || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            ADDRESS INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>Site Address</label>
                            <span>{warranty.site_address || ""}</span>
                          </Col>
                          {/* //Added by shahir hussain */}
                          <Col lg={6}>
                            <label>Area</label>
                            <span>{warranty?.area || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>State</label>
                            <span>{warranty.state || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>City</label>
                            <span>{warranty.city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office Address</label>
                            <span>{warranty.office_address || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office City</label>
                            <span>{warranty.office_city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Pincode</label>
                            <span>{warranty.pincode || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Country</label>
                            <span>{warranty.country || ""}</span>
                          </Col>
                        </>

                        <Col lg={12}>
                          <div
                            id="googleMapaddress"
                            className="my-2"
                            style={{
                              width: "100%",
                              height: "300px",
                              border: "1px solid black",
                            }}
                          ></div>
                        </Col>


                        {/*Imran Khan Update Lead View page for Warranty Lost Lead Information*/}
                        {
                          warranty.warranty_status === 'Warranty Lost' &&
                          <>
                            <Col lg={12} className="section-header">
                              WARRANTY LOST INFORMATION
                            </Col>
                            <Col lg={6}>
                              <label>Lost Date</label>
                              <span>{formatDateForCreatedDate(warranty?.lost_date || "")}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lead Lost Remark</label>
                              <span>{warranty.lost_remark}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lost By (Company)</label>
                              <span>{warranty.lost_by_reason}</span>
                            </Col>
                          </>}
                        {/*End Imran Khan Update Lead View page for Enquiry Lost Lead Information*/}
                      </Row>
                    )}

                    {/* {showNotesMessages && (
                        <Card className="mt-2">
                          <Row className="mt-4">
                            <Col lg={12}>
                              <Chat parentid={warranty.id} />
                            </Col>
                          </Row>
                        </Card>
                      )} */}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="d-flex justify-content-between">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleRelatedListTab(key)}
              >
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) && (
                    <Tab eventKey="files" title="Files"></Tab>
                  )}
                {/* {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) && (
                    <Tab eventKey="tasks" title="Tasks"></Tab>
                  )} */}

              </Tabs>


              {(relatedListFiles && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowFile(true)}
                  >
                    New File
                  </Button>
                )}
              {/* 
              {(relatedListTaskList && [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
              })) && (
                <Button
                  size="sm"
                  className="btn-custom float-right"
                  onClick={() => setModalShowTask(true)}
                >
                  New Task
                </Button>
              )} */}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={warranty}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}

              {/* {modalShowTask && (
                <TaskEdit
                  show={modalShowTask}
                  onHide={() => setModalShowTask(false)}
                  parentid={warranty?.id}
                  table="warranty"
                  submitTasks={submitTasks}
                />
              )} */}

            </Card.Header>
            <Card.Body>
              {(relatedListFiles && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(permission => { return userInfo?.permissions?.map(p => p.name).includes(permission); }))
                && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    // onFileUpdate={updateCounter}
                    parent={warranty}
                    submitFiles={submitFiles}
                  />
                )}

              {/* {(relatedListTaskList && [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => 
              { return userInfo?.permissions?.map(p => p.name).includes(permission); })) 
              && (
                <RelatedListTask
                  refreshTaskList={refreshTaskList}
                  parent={warranty}
                  submitFiles={submitTasks}
                  table="Order"
                />
              )} */}
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};
export default WarrantyView;
